module.exports = __webpack_public_path__ + "img/pneumonia-dark.01fdf809.svg";